// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/mafia/MafiaOverlay.css */

/* --- ФОН ОВЕРЛЕЯ --- */
.mafia-overlay-bg {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.85);
  z-index: 5000;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(4px);
  animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
@keyframes slideUp { from { transform: translateY(50px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }

/* ========================================= */
/* БАЗОВЫЙ КЛАСС КАРТОЧКИ */
/* ========================================= */
.mafia-generic-card {
  width: 90%;
  max-width: 340px;
  min-height: 200px;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  /* Анимация только если это не превью в селекторе (там мы отключаем inline-стилем) */
  animation: slideUp 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  box-sizing: border-box;
}

/* Внутренние элементы */
.mpc-header {
  padding: 20px;
  text-align: center;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.mpc-icon { font-size: 48px; margin-bottom: 10px; line-height: 1; }
.mpc-title { font-size: 25px; font-weight: 900; text-transform: uppercase; line-height: 1.2; }

.mpc-content {
  padding: 15px 22px;
  text-align: left;
  font-size: 17px;
  line-height: 1.5;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.mpc-desc { width: 100%; }

.mpc-target-word {
  display: inline-block;
  padding: 8px 15px;
  margin: 10px 0;
  font-weight: bold;
  font-size: 22px;
  text-transform: uppercase;
}

.mpc-teammates {
  font-size: 14px;
  background: rgba(0,0,0,0.05);
  padding: 12px;
  border-radius: 8px;
  width: 100%;
  box-sizing: border-box;
}

.mpc-button {
  margin: 0 20px 25px 20px;
  padding: 14px 0;
  cursor: pointer;
  font-weight: 750;
  font-size: 18px;
  text-transform: uppercase;
  border: none;
  border-radius: 12px;
  transition: transform 0.1s, opacity 0.2s;
  text-align: center;
  flex-shrink: 0;
}
.mpc-button:active { transform: scale(0.98); opacity: 0.9; }
.mpc-button.secondary { background: transparent; border: 1px solid currentColor; margin-top: -15px; font-size: 12px; padding: 10px 0;}

/* Лоадер (Спиннер) */
.mafia-loader-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: currentColor; /* Берет цвет текста текущей темы */
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 15px auto;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Адаптация цвета спиннера для темных тем */
.theme-neon .mafia-loader-spinner,
.theme-cyber-pro .mafia-loader-spinner,
.theme-dark .mafia-loader-spinner {
  border: 4px solid rgba(255, 255, 255, 0.1);
  border-left-color: #fff;
}

/* Блок определения слова */
.mpc-definition {
  font-size: 13px;
  line-height: 1.3;
  color: currentColor; /* Наследует цвет текста темы */
  opacity: 0.85;       /* Чуть менее яркий, чем основной текст */
  margin-top: 1px;
  margin-bottom: 1px;
  font-style: italic;
  text-align: left;
  white-space: pre-wrap; /* Сохраняет переносы строк */

  /* Легкая подложка для читаемости на сложных фонах */
  background: rgba(0, 0, 0, 0.06);
  padding: 6px 8px;
  border-radius: 8px;
  width: 100%;
  box-sizing: border-box;
}

/* Адаптация для темных тем (если нужно инвертировать подложку) */
.theme-neon .mpc-definition,
.theme-cyber-pro .mpc-definition,
.theme-dark .mpc-definition {
  background: rgba(255, 255, 255, 0.1);
}
`, "",{"version":3,"sources":["webpack://./src/components/mafia/MafiaOverlay.css"],"names":[],"mappings":"AAAA,0CAA0C;;AAE1C,wBAAwB;AACxB;EACE,eAAe;EACf,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA,oBAAoB,OAAO,UAAU,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;AAC5D,qBAAqB,OAAO,2BAA2B,EAAE,UAAU,EAAE,EAAE,KAAK,wBAAwB,EAAE,UAAU,EAAE,EAAE;;AAEpH,8CAA8C;AAC9C,2BAA2B;AAC3B,8CAA8C;AAC9C;EACE,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,oFAAoF;EACpF,+DAA+D;EAC/D,sBAAsB;AACxB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,YAAY,eAAe,EAAE,mBAAmB,EAAE,cAAc,EAAE;AAClE,aAAa,eAAe,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,gBAAgB,EAAE;;AAE7F;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,YAAY,WAAW,EAAE;;AAEzB;EACE,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,cAAc;AAChB;AACA,qBAAqB,sBAAsB,EAAE,YAAY,EAAE;AAC3D,wBAAwB,uBAAuB,EAAE,8BAA8B,EAAE,iBAAiB,EAAE,eAAe,EAAE,eAAe,CAAC;;AAErI,qBAAqB;AACrB;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,+BAA+B,EAAE,mCAAmC;EACpE,kBAAkB;EAClB,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,4CAA4C;AAC5C;;;EAGE,0CAA0C;EAC1C,uBAAuB;AACzB;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB,EAAE,+BAA+B;EACpD,aAAa,QAAQ,yCAAyC;EAC9D,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB,EAAE,6BAA6B;;EAEpD,oDAAoD;EACpD,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;;AAEA,iEAAiE;AACjE;;;EAGE,oCAAoC;AACtC","sourcesContent":["/* src/components/mafia/MafiaOverlay.css */\n\n/* --- ФОН ОВЕРЛЕЯ --- */\n.mafia-overlay-bg {\n  position: fixed;\n  top: 0; left: 0; right: 0; bottom: 0;\n  background: rgba(0, 0, 0, 0.85);\n  z-index: 5000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  backdrop-filter: blur(4px);\n  animation: fadeIn 0.3s ease-out;\n}\n\n@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }\n@keyframes slideUp { from { transform: translateY(50px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }\n\n/* ========================================= */\n/* БАЗОВЫЙ КЛАСС КАРТОЧКИ */\n/* ========================================= */\n.mafia-generic-card {\n  width: 90%;\n  max-width: 340px;\n  min-height: 200px;\n  border-radius: 16px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  position: relative;\n  /* Анимация только если это не превью в селекторе (там мы отключаем inline-стилем) */\n  animation: slideUp 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  box-sizing: border-box;\n}\n\n/* Внутренние элементы */\n.mpc-header {\n  padding: 20px;\n  text-align: center;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.mpc-icon { font-size: 48px; margin-bottom: 10px; line-height: 1; }\n.mpc-title { font-size: 25px; font-weight: 900; text-transform: uppercase; line-height: 1.2; }\n\n.mpc-content {\n  padding: 15px 22px;\n  text-align: left;\n  font-size: 17px;\n  line-height: 1.5;\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.mpc-desc { width: 100%; }\n\n.mpc-target-word {\n  display: inline-block;\n  padding: 8px 15px;\n  margin: 10px 0;\n  font-weight: bold;\n  font-size: 22px;\n  text-transform: uppercase;\n}\n\n.mpc-teammates {\n  font-size: 14px;\n  background: rgba(0,0,0,0.05);\n  padding: 12px;\n  border-radius: 8px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.mpc-button {\n  margin: 0 20px 25px 20px;\n  padding: 14px 0;\n  cursor: pointer;\n  font-weight: 750;\n  font-size: 18px;\n  text-transform: uppercase;\n  border: none;\n  border-radius: 12px;\n  transition: transform 0.1s, opacity 0.2s;\n  text-align: center;\n  flex-shrink: 0;\n}\n.mpc-button:active { transform: scale(0.98); opacity: 0.9; }\n.mpc-button.secondary { background: transparent; border: 1px solid currentColor; margin-top: -15px; font-size: 12px; padding: 10px 0;}\n\n/* Лоадер (Спиннер) */\n.mafia-loader-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid rgba(0, 0, 0, 0.1);\n  border-left-color: currentColor; /* Берет цвет текста текущей темы */\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin: 0 auto 15px auto;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Адаптация цвета спиннера для темных тем */\n.theme-neon .mafia-loader-spinner,\n.theme-cyber-pro .mafia-loader-spinner,\n.theme-dark .mafia-loader-spinner {\n  border: 4px solid rgba(255, 255, 255, 0.1);\n  border-left-color: #fff;\n}\n\n/* Блок определения слова */\n.mpc-definition {\n  font-size: 13px;\n  line-height: 1.3;\n  color: currentColor; /* Наследует цвет текста темы */\n  opacity: 0.85;       /* Чуть менее яркий, чем основной текст */\n  margin-top: 1px;\n  margin-bottom: 1px;\n  font-style: italic;\n  text-align: left;\n  white-space: pre-wrap; /* Сохраняет переносы строк */\n\n  /* Легкая подложка для читаемости на сложных фонах */\n  background: rgba(0, 0, 0, 0.06);\n  padding: 6px 8px;\n  border-radius: 8px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* Адаптация для темных тем (если нужно инвертировать подложку) */\n.theme-neon .mpc-definition,\n.theme-cyber-pro .mpc-definition,\n.theme-dark .mpc-definition {\n  background: rgba(255, 255, 255, 0.1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
